import {
  TipoDomandaDTOCopertina,
  getGetImmaginiAltQueryKey,
  useGetImmaginiAlt,
} from '@framework/api-client';
import { CoverImageContainer } from '@framework/common-web';
import { useCurrentLocale } from '@framework/i18n';
import * as React from 'react';
import { useEffect } from 'react';
import { queryClient } from '../../../../core/network/queryClient';
import { getImageUrl } from './getImageUrl';

export interface ICoverImageProps {
  cover?: TipoDomandaDTOCopertina | null;
}

export function CoverImage(props: ICoverImageProps) {
  const { cover } = props;
  const coverImage = cover?.sfondo;

  const locale = useCurrentLocale();

  const alt = useGetImmaginiAlt(
    { ids: [coverImage!] },
    {
      query: { enabled: !!coverImage },
      request: {
        arrayFormat: 'repeat',
      },
    },
  );

  useEffect(() => {
    if (!coverImage) return;
    queryClient.invalidateQueries(
      getGetImmaginiAltQueryKey({ ids: [coverImage] }),
    );
  }, [coverImage, locale.tag]);

  const imageAlt = alt.data?.data?.at(0)?.alt ?? 'Immagine';

  return (
    coverImage && (
      <CoverImageContainer>
        <img alt={imageAlt} src={getImageUrl(cover?.sfondo, locale.tag)} />
      </CoverImageContainer>
    )
  );
}
